import { lazy } from 'react';
import Appeal from 'views/appeal/Appeal';
import Config from 'views/config/Config';
import Holidays from 'views/masters/holidays/Holidays';

const User = lazy(() => import('views/user/User'));
const Shift = lazy(() => import('views/shift/Shift'));
const Transaction = lazy(() => import('views/transaction/Transaction'));
const Dashboard = lazy(() => import('views/dashboard/Dashboard'));
const Division = lazy(() => import('views/masters/divisions/Divisions'));
const Shifts = lazy(() => import('views/masters/shifts/Shifts'));
const Device = lazy(() => import('views/device/Device'));
const TesterDevice = lazy(() => import('views/device/TesterDevice'));
const Report = lazy(() => import('views/report/Report'));

const routes = [
  {
    id: 'user',
    path: '/user',
    navbar: true,
    title: 'Karyawan',
    icon: 'user',
    component: User,
    hr: true,
    access: ['HR'],
    sub: [
      {
        id: 'user-active',
        path: '/active',
        navbar: true,
        title: 'Karyawan Aktif',
        component: User,
      },
      {
        id: 'user-inactive',
        path: '/inactive',
        navbar: true,
        title: 'Karyawan Non-Aktif',
        component: User,
      },
      {
        id: 'user-testing',
        path: '/testing',
        navbar: true,
        title: 'User Testing',
        component: User,
      },
    ],
  },
  {
    id: 'shift',
    path: '/shift',
    navbar: true,
    title: 'Shift',
    icon: 'calendar-alt',
    component: Shift,
    access: ['HR', 'SPV'],
  },
  {
    id: 'dashboard',
    path: '/dashboard',
    navbar: true,
    title: 'Dashboard',
    icon: 'chart-line',
    component: Dashboard,
    hr: true,
    access: ['HR'],
  },
  {
    id: 'transaction',
    path: '/transaction',
    navbar: true,
    title: 'Transaksi',
    icon: 'list',
    component: Transaction,
    access: ['HR', 'SPV'],
  },
  {
    id: 'appeals',
    path: '/appeals',
    navbar: true,
    title: 'Sanggahan',
    icon: 'envelope',
    component: Appeal,
    access: ['HR'],
  },
  {
    id: 'devices',
    navbar: true,
    path: '/devices',
    title: 'Perangkat',
    icon: 'mobile-alt',
    hr: true,
    access: ['HR'],
    sub: [
      {
        id: 'devices-user',
        path: '/user1',
        navbar: true,
        title: 'User',
        component: Device,
      },
      {
        id: 'devices-tester',
        path: '/tester',
        navbar: true,
        title: 'Tester',
        component: TesterDevice,
      },
    ],
  },
  {
    id: 'config',
    path: '/config',
    navbar: true,
    title: 'Konfigurasi',
    icon: 'wrench',
    component: Config,
    hr: true,
  },
  {
    id: 'report',
    path: '/report',
    navbar: true,
    title: 'Laporan',
    icon: 'download',
    component: Report,
    hr: true,
  },
  {
    id: 'master',
    path: '/master',
    navbar: true,
    title: 'Data Master',
    icon: 'database',
    access: ['HR'],
    sub: [
      {
        id: 'division',
        path: '/master/division',
        navbar: true,
        title: 'Divisi',
        icon: 'briefcase',
        component: Division,
      },
      {
        id: 'shift',
        path: '/master/shift',
        navbar: true,
        title: 'Shift',
        icon: 'briefcase',
        component: Shifts,
      },
      {
        id: 'holiday',
        path: '/master/holiday',
        navbar: true,
        title: 'Libur',
        icon: 'briefcase',
        component: Holidays,
      },
    ],
    hr: true,
  },
  {
    redirect: true,
    from: '/',
    to: '/user/active',
  },
];

export default routes;
